import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from "@angular/router";
import {AuthService} from "@services/auth.service";
import {MessageService} from "primeng/api";
import {environment} from '@root/src/environments/environment';

@Injectable()
export class DebugInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private authService: AuthService,
        private messageService: MessageService,
    ) {
    }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.body) {
        }
        console.groupEnd();

        return next.handle(req).pipe(
            tap(
                event => {

                },
                error => {

                    if (error instanceof HttpErrorResponse) {
                       if (error.status !== 404) {
                         if (environment.showAlertLevel.Error) {
                           this.messageService.add({
                             severity: 'error',
                             summary: 'Error',
                             detail: this.handleErrors(error),
                           });
                         }

                        }
                        if (error.status === 401 && !this.router.url.includes('/login')) {
                            const isWeatherEndpoint = req.url.includes('Era5HourWeatherForecast') ||
                                                     req.url.includes('Era5WeatherReportTiles') ||
                                                     req.url.includes('weatherReports');

                            if (!isWeatherEndpoint) {
                                localStorage.removeItem(this.authService.tokenKey);
                                this.router.navigate(['/login']);
                            }
                        }
                    }
                }
            )
        );
    }

    handleErrors(errorResponse: any): string {
        const errorMsg = typeof errorResponse.error === 'string' ? errorResponse.error : null;

        const errorMessages: string[] = [];

        if (errorResponse && errorResponse.error && errorResponse.error.errors) {
            const errors = errorResponse.error.errors;
            if (errors && typeof errors === 'object') {
                Object.keys(errors).forEach(key => {
                    const messages = errors[key];
                    if (Array.isArray(messages)) {
                        errorMessages.push(...messages);
                    }
                });
            }
        }

        return errorMsg || errorMessages.join(', ') || 'An unknown error occurred';
    }
}
